var _rect, _rect2, _rect3, _rect4, _path, _rect5, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.9307,
    y: 20,
    width: 61.2157,
    height: 76.8755,
    rx: 10,
    fill: "#B1CBF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4377,
    y: 49.8965,
    width: 22.7779,
    height: 5.69448,
    rx: 2.84724,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4377,
    y: 64.1328,
    width: 17.0834,
    height: 5.69448,
    rx: 2.84724,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 38.5068,
    width: 32.7433,
    height: 38.4377,
    rx: 5,
    fill: "#7DA9E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 60.5V63.8333C31.5 64.2754 31.3244 64.6993 31.0118 65.0118C30.6993 65.3244 30.2754 65.5 29.8333 65.5H18.1667C17.7246 65.5 17.3007 65.3244 16.9882 65.0118C16.6756 64.6993 16.5 64.2754 16.5 63.8333V60.5M28.1667 54.6667L24 50.5M24 50.5L19.8333 54.6667M24 50.5V60.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3337,
    y: 37.5068,
    width: 34.7433,
    height: 40.4377,
    rx: 6,
    fill: "#2F75DA",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 60.5V63.8333C99.5 64.2754 99.3244 64.6993 99.0118 65.0118C98.6993 65.3244 98.2754 65.5 97.8333 65.5H86.1667C85.7246 65.5 85.3007 65.3244 84.9882 65.0118C84.6756 64.6993 84.5 64.2754 84.5 63.8333V60.5M96.1667 54.6667L92 50.5M92 50.5L87.8333 54.6667M92 50.5V60.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportBig);
export default __webpack_public_path__ + "static/media/export-big.efa929d714c94449ab0c36a927addce5.svg";
export { ForwardRef as ReactComponent };